import { FlashUIComponent } from "./FlashUIComponent";

import Container = createjs.Container;

export class AnimatedFlashUIComponent extends FlashUIComponent {
    constructor(disp: Container) {
        super(disp);
    }

    /**
     * use the methode to animatied the Flash component
     */
    public onEnterFrameUpdate(): void {
    }
}

